import { render, staticRenderFns } from "./mindmap.vue?vue&type=template&id=310225c6"
import script from "./mindmap.vue?vue&type=script&lang=js"
export * from "./mindmap.vue?vue&type=script&lang=js"
import style0 from "./mindmap.vue?vue&type=style&index=0&id=310225c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports